import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import BcSepIcon     from "../../../asset/images/about/breadcrumb-separator.svg";
import HeroBgImg     from "../../../asset/images/power&surveillance/liferaft-modular/hero-bg.webp";
import HeroMobileImg from "../../../asset/images/power&surveillance/liferaft-modular/hero-bg-mobile.webp";
import Lm1Img        from "../../../asset/images/power&surveillance/liferaft-modular/liferaft-modular-1.webp";
import Lm2Img        from "../../../asset/images/power&surveillance/liferaft-modular/liferaft-modular-2.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .lm { font-family: 'Poppins', sans-serif; color: #202020; background: #fff; }

  .lm-hero {
    position: relative;
    width: 100%;
    height: 465px;
    overflow: hidden;
    background: #fbe8e7;
  }
  .lm-hero-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }
  .lm-hero-bg-mobile {
    display: none;
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
  .lm-hero-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 102px;
    max-width: 1600px;
    margin: 0 auto;
    left: 0; right: 0;
  }
  .lm-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    font-weight: 600;
    color: #202020;
    line-height: 120%;
    max-width: 524px;
  }
  .lm-hero-title em { font-style: normal; color: #EB2019; }

  /* SUBNAV */
  .lm-subnav {
    width: 100%;
    background: #EB2019;
    position: sticky;
    top: 162px;
    z-index: 100;
    overflow: visible;
  }
  .lm-subnav-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: stretch;
    white-space: nowrap;
    overflow: visible;
  }
  .lm-subnav-item {
    position: relative;
    flex-shrink: 0;
  }
  .lm-subnav-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    text-decoration: none;
    cursor: pointer;
    transition: background 0.15s;
    border: 1px solid #A40000;
    background: #B91E1A;
    white-space: nowrap;
    height: 100%;
  }
  .lm-subnav-link.lm-active { font-weight: 500; }
  .lm-subnav-link:hover { background: rgba(0,0,0,0.15); }
  .lm-subnav-chevron {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-right: 2px solid rgba(255,255,255,0.9);
    border-bottom: 2px solid rgba(255,255,255,0.9);
    transform: rotate(45deg) translateY(-2px);
    flex-shrink: 0;
    transition: transform 0.2s;
  }
  .lm-subnav-chevron.open { transform: rotate(-135deg) translateY(-2px); }

  /* DROPDOWN — position:absolute */
  .lm-subnav-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 312px;
    background: #fff;
    border: 1px solid #7A7A7A;
    z-index: 9999;
  }
  .lm-subnav-dropdown-item {
    display: block;
    padding: 15px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    text-decoration: none;
    border-bottom: 1px solid #EB2019;
    transition: background 0.15s;
    cursor: pointer;
  }
  .lm-subnav-dropdown-item:last-child { border-bottom: none; }
  .lm-subnav-dropdown-item:hover { background: #f9f9f9; color: #EB2019; }
  .lm-subnav-dropdown-item.lm-dd-active { color: #EB2019; font-weight: 500; }

  /* MOBILE BAR */
  .lm-mobile-bar {
    display: none;
    width: 100%;
    background: #B91E1A;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    height: 56px;
    position: sticky;
    top: 72px;
    z-index: 100;
  }
  .lm-mobile-bar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
  }
  .lm-hamburger {
    display: flex;
    flex-direction: column;
    gap: 5px;
    cursor: pointer;
    background: none;
    border: none;
    padding: 4px;
  }
  .lm-hamburger span {
    display: block;
    width: 22px;
    height: 2px;
    background: #fff;
    border-radius: 2px;
  }

  /* MOBILE SIDEBAR */
  .lm-sidebar-overlay {
    display: none;
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.4);
    z-index: 500;
  }
  .lm-sidebar-overlay.open { display: block; }
  .lm-sidebar {
    position: fixed;
    top: 80px;
    left: 0;
    width: 275px;
    max-width: 100vw;
    height: 614px;
    background: #fff;
    z-index: 600;
    display: flex;
    flex-direction: column;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    overflow-y: auto;
    border: 1px solid #7A7A7A;
  }
  .lm-sidebar.open { transform: translateX(0); }
  .lm-sidebar-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #B91E1A;
    padding: 0 20px;
    height: 56px;
    flex-shrink: 0;
  }
  .lm-sidebar-header-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
  }
  .lm-sidebar-close {
    background: none;
    border: none;
    cursor: pointer;
    color: #fff;
    font-size: 22px;
    line-height: 1;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .lm-sidebar-nav { flex: 1; overflow-y: auto; }
  .lm-sidebar-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    border-bottom: 0.7px solid #7A7A7A;
    cursor: pointer;
    background: none;
    border-left: none;
    border-right: none;
    border-top: none;
    width: 100%;
    text-align: left;
    text-decoration: none;
  }
  .lm-sidebar-row:hover { background: #fafafa; }
  .lm-sidebar-row.active { color: #000000; font-weight: 400; }
  .lm-sidebar-chevron {
    display: inline-block;
    width: 9px;
    height: 9px;
    border-right: 2px solid #888;
    border-bottom: 2px solid #888;
    transform: rotate(45deg) translateY(-2px);
    flex-shrink: 0;
    transition: transform 0.2s;
  }
  .lm-sidebar-chevron.open { transform: rotate(-135deg) translateY(-2px); }
  .lm-sidebar-subitems { border-bottom: 1px solid #efefef; }
  .lm-sidebar-subitem {
    display: block;
    padding: 8px 59px 8px 46px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 300;
    color: #202020;
    text-decoration: none;
    border-bottom: 0.7px solid #EB2019;
    cursor: pointer;
  }
  .lm-sidebar-subitem:last-child { }
  .lm-sidebar-subitem:hover { background: #fafafa; }
  .lm-sidebar-subitem.active { color: #B91E1A; font-weight: 400; }

  /* BREADCRUMB */
  .lm-breadcrumb { padding: 60px 0 0 0; }
  .lm-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 14px;
  }
  .lm-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    transition: color 0.15s;
  }
  .lm-bc-item:hover { color: #EB2019; }
  .lm-bc-item.active { color: #202020; }
  .lm-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 8px;
    flex-shrink: 0;
  }

  /* INNER */
  .lm-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }

  /* DIVIDER */
  .lm-divider {
    max-width: 1600px;
    margin: 0 auto;
    padding: 80px 102px 0px 102px;
  }
  .lm-divider hr {
    border: none;
    border-top: 1px solid #EB2019;
    opacity: 0.3;
  }
  .lm-divider-slim {
    max-width: 1600px;
    margin: 0 auto;
    padding: 60px 102px 0 102px;
  }
  .lm-divider-slim hr {
    border: none;
    border-top: 1px solid #EB2019;
    opacity: 0.3;
  }

  /* SCROLL ANCHOR */
  .lm-anchor { scroll-margin-top: 180px; }

  /* CONTENT */
  .lm-section-content { padding: 80px 0 0 0; }
  .lm-content-grid {
    display: flex;
    gap: 80px;
    align-items: center;
  }
  .lm-content-left { flex: 0 0 766px; }
  .lm-img-col {
    flex: 1;
    align-self: stretch;
    background: #F5F5F5;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .lm-img-wrap {
    width: 100%;
    height: 100%;
    max-height: 650px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .lm-product-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }

  /* typography */
  .lm-red-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 600;
    color: #EB2019;
    margin-bottom: 24px;
    line-height: 120%;
  }
  .lm-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 600;
    color: #202020;
    margin-bottom: 14px;
  }
  .lm-para {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #7A7A7A;
    line-height: 140%;
  }
  .lm-para + .lm-para { margin-top: 14px; }
  .lm-features-tag {
    display: inline-flex;
    align-items: stretch;
    margin: 34px 0 34px 0;
  }
  .lm-features-tag-bar {
    width: 10px;
    background: #EB2019;
    flex-shrink: 0;
  }
  .lm-features-tag-text {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #202020;
    background: #FFE6E5;
    padding: 18px 27px;
  }
  .lm-features-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .lm-features-list li {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
    padding: 4px 0 4px 20px;
    position: relative;
  }
  .lm-features-list li::before {
    content: '•';
    position: absolute;
    left: 0;
    color: #202020;
  }

  /* ══ RESPONSIVE 768px ══ */
  @media (max-width: 768px) {
    .lm-hero-bg        { display: block; }
    .lm-subnav         { top: 70px; }
    .lm-anchor         { scroll-margin-top: 110px; }
    .lm-subnav-inner   { padding: 0 16px; overflow-x: auto; }
    .lm-subnav-link    { padding: 16px 14px; font-size: 13px; }
    .lm-hero              { height: 300px; }
    .lm-hero-content      { padding: 0 32px; }
    .lm-hero-title        { font-size: 26px; }
    .lm-breadcrumb        { padding: 28px 0 0 0; }
    .lm-breadcrumb-inner  { padding: 0 24px; }
    .lm-inner             { padding: 0 24px; }
    .lm-divider           { padding: 0px 32px 0px 32px; }
    .lm-divider:last-child { display: none; }
    .lm-divider-slim      { padding: 20px 24px 0 24px; }
    .lm-section-content   { padding: 40px 0 0 0; }
    .lm-content-grid      { flex-direction: column-reverse !important; gap: 30px; }
    .lm-content-left      { flex: none; width: 100%; }
    .lm-features-tag      { margin: 24px 0 24px 0; }
    .lm-features-tag-text { font-size: 14px; padding: 14px 24px; }
    .lm-img-col           { min-height: 260px; width: 100%; }
    .lm-img-wrap          { max-height: 450px; }
    .lm-red-title         { font-size: 24px; margin-bottom: 10px; }
    .lm-subtitle          { font-size: 18px; margin-bottom: 10px; }
    .lm-para              { font-size: 14px; }
    .lm-para + .lm-para   { margin-top: 10px; }
    .lm-features-list li  { font-size: 14px; }
    .lm-content-grid:last-child { margin-bottom: 40px !important; }
  }

  /* ══ RESPONSIVE 480px ══ */
  @media (max-width: 480px) {
    .lm-subnav           { display: none; }
    .lm-mobile-bar       { display: flex; height: 46px; }
    .lm-sidebar-header   { height: 46px; }
    .lm-anchor           { scroll-margin-top: 80px; }
    .lm-hero-bg          { display: none; }
    .lm-hero-bg-mobile   { display: block; }
    .lm-hero             { height: 370px; }
    .lm-hero-content     { padding: 0 16px; justify-content: flex-start; padding-top: 76px; }
    .lm-hero-title       { font-size: 22px; }
    .lm-breadcrumb       { padding: 22px 0 0 0; }
    .lm-breadcrumb-inner { padding: 0 16px; gap: 6px; }
    .lm-bc-item          { font-size: 14px; }
    .lm-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .lm-inner            { padding: 0 16px; }
    .lm-divider          { padding: 0px 16px; }
    .lm-divider-slim     { padding: 30px 16px 0 16px; }
    .lm-section-content  { padding: 60px 0 0 0; }
    .lm-section-content:last-child { padding: 60px 0 0px 0; }
    .lm-divider:last-child { display: none; }
    .lm-content-grid:last-child { margin-bottom: 60px !important; }
    .lm-content-grid     { gap: 30px; flex-direction: column-reverse !important; }
    .lm-img-wrap         { max-height: 260px; }
    .lm-red-title        { font-size: 20px; margin-bottom: 10px; }
    .lm-subtitle         { font-size: 16px; margin-bottom: 10px; }
    .lm-para             { font-size: 14px; }
    .lm-features-list li { font-size: 14px; }
  }
`;

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const SUBNAV = [
  {
    label: "HP Series",
    chevron: true,
    href: "/power-surveillance/hp-series",
    children: [
      { label: "HP SERIES (1 KVA To 3 KVA ONLINE UPS)", href: "/power-surveillance/hp-series#hp-product-1" },
      { label: "HP SERIES (6 KVA To 10 KVA)",           href: "/power-surveillance/hp-series#hp-product-2" },
      { label: "HP SERIES (10 KVA To 20 KVA)",          href: "/power-surveillance/hp-series#hp-product-3" },
    ],
  },
  { label: "Prime & Master Series", chevron: false, href: "/power-surveillance/prime-master-series" },
  {
    label: "Liferaft Modular",
    chevron: true,
    active: true,
    href: "/power-surveillance/liferaft-modular",
    children: [
      { label: "Liferaft Modular 25kVA To 400kVA", anchor: "lm-product-1", active: true },
      { label: "Liferaft Modular 25kVA To 600kVA", anchor: "lm-product-2" },
    ],
  },
  { label: "Power+ Series", chevron: false, href: "/power-surveillance/power-plus-series" },
  { label: "Liferaft",      chevron: false, href: "/power-surveillance/liferaft" },
  {
    label: "Star+ Tx Series",
    chevron: true,
    href: "/power-surveillance/star-tx-series",
    children: [
      { label: "STAR Tx SERIES (6 KVA – 40 KVA)",    href: "/power-surveillance/star-tx-series#st-product-1" },
      { label: "STAR+ Tx SERIES (10 KVA – 300 KVA)",  href: "/power-surveillance/star-tx-series#st-product-2" },
    ],
  },
  { label: "Star+ Series",                                   chevron: false, href: "/power-surveillance/star-plus-series" },
  { label: "Star+ Series Microcontroller Based Stabilizers", chevron: false, href: "/power-surveillance/star-plus-series-microcontroller-stabilizers" },
];

const PRODUCTS = [
  {
    id: 1,
    anchor: "lm-product-1",
    title:    "LIFERAFT MODULAR",
    subtitle: "(25kVA/KW To 400kVA/KW) Next Generation\nModular UPS 3:3 Phase PF : 1 (Unity)",
    paras: [
      "LIFERAFT is a true online modular Uninterrupted Power Supply system based on True Online Battery Topology, upgraded from 25kVA/kW-100kVA/kW Hot swappable module & Static Switch, in parallel up to 400kVA/kW. LIFERAFT has maximum safety without transferring the load to bypass source. LIFERAFT is a next generation system specially designed with unmatched reliability, pure power quality and very high electrical efficiency for critical applications with 7\" Touch Screen Display.",
    ],
    features: [
      "Three Level IGBT topology, DSP control with best reliability and high performance",
      "Most compact footprint with unique light weight.",
      "Compact design having wide input voltage window.",
      "Regenerative back feed protection",
      "High Input Power Factor >0.99,",
      "Low input THDi <5%,",
      "High overall Efficiency upto 95%",
      "Inverter Overload-110%- 60min; 125%-10min & 150%-1min",
      "7\" Display-touch colour LCD+LED+ Keyboard",
      "Compatible with Lithium-ion Battery and BMS",
    ],
    imgRight: true,
    imgSrc: Lm1Img,
  },
  {
    id: 2,
    anchor: "lm-product-2",
    title:    "LIFERAFT MODULAR",
    subtitle: "(25kVA/KW To 600kVA/KW) Next Generation\nModular UPS 3:3 Phase PF : 1 (Unity)",
    paras: [
      "LIFERAFT is a true online modular Uninterrupted Power Supply system based on True Online Battery Topology,  upgraded from 25kVA/kW-150kVA/kW Hot swappable module & Static Switch, in parallel up to 600kVA/kW. LIFERAFT has  maximum safety without transferring the load to bypass source. LIFERAFT is a next generation system specially  designed with unmatched reliability, pure power quality and very high electrical efficiency for critical applications  with 10.5\" Touch Screen Display",
    ],
    features: [
      "Three Level IGBT topology, DSP control with best reliability  and high performance.",
      "Most compact footprint with unique light weight.",
      "Compact design having wide input voltage window.",
      "Regenerative back feed protection",
      "High Input Power Factor >0.99,",
      "Low input THDi <5%,",
      "High overall Efficiency upto 95%,",
      "Inverter Overload-110%- 60min; 125%-10min & 150%-1min;",
      "10.5\" Display-touch colour LCD+LED+ Keyboard",
      "Compatible with Lithium-ion Battery and BMS",
    ],
    imgRight: false,
    imgSrc: Lm2Img,
  },
];

/* ── SubnavItem — position:absolute dropdown, hover ── */
function SubnavItem({ item }) {
  const [open, setOpen] = useState(false);

  if (!item.chevron || !item.children?.length) {
    return (
      <div className="lm-subnav-item">
        <a href={item.href || "#"} className={`lm-subnav-link${item.active ? " lm-active" : ""}`}>
          {item.label}
        </a>
      </div>
    );
  }

  return (
    <div
      className="lm-subnav-item"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <a href={item.href || "#"} className={`lm-subnav-link${item.active ? " lm-active" : ""}`}>
        {item.label}
        <span className={`lm-subnav-chevron${open ? " open" : ""}`} />
      </a>
      {open && (
        <div className="lm-subnav-dropdown">
          {item.children.map((child, i) => (
            <a
              key={i}
              href={child.href || `#${child.anchor}`}
              className={`lm-subnav-dropdown-item${child.active ? " lm-dd-active" : ""}`}
              onClick={(e) => {
                if (child.anchor && !child.href) {
                  e.preventDefault();
                  scrollTo(child.anchor);
                }
                setOpen(false);
              }}
            >
              {child.label}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}

/* ── SidebarRow ── */
function SidebarRow({ item, onClose }) {
  const [open, setOpen] = useState(item.active && item.children?.length > 0);

  if (!item.chevron || !item.children?.length) {
    return (
      <a href={item.href || "#"} className={`lm-sidebar-row${item.active ? " active" : ""}`} onClick={onClose}>
        {item.label}
      </a>
    );
  }

  return (
    <>
      <button
        className={`lm-sidebar-row${item.active ? " active" : ""}`}
        onClick={() => setOpen(o => !o)}
      >
        {item.label}
        <span className={`lm-sidebar-chevron${open ? " open" : ""}`} />
      </button>
      {open && (
        <div className="lm-sidebar-subitems">
          {item.children.map((child, i) => (
            <a
              key={i}
              href={child.href || `#${child.anchor}`}
              className={`lm-sidebar-subitem${child.active ? " active" : ""}`}
              onClick={(e) => {
                if (child.anchor && !child.href) {
                  e.preventDefault();
                  onClose();
                  setTimeout(() => scrollTo(child.anchor), 320);
                } else {
                  onClose();
                }
              }}
            >
              {child.label}
            </a>
          ))}
        </div>
      )}
    </>
  );
}

export default function LiferaftModular() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash?.replace("#", "");
    if (!hash) return;
    const tryScroll = () => {
      const el = document.getElementById(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        setTimeout(tryScroll, 100);
      }
    };
    const timer = setTimeout(tryScroll, 300);
    return () => clearTimeout(timer);
  }, [location.hash]);

  return (
    <>
      <style>{CSS}</style>

      {/* HERO */}
      <div className="lm">
        <section className="lm-hero">
          <img className="lm-hero-bg" src={HeroBgImg} alt="" />
          <img className="lm-hero-bg-mobile" src={HeroMobileImg} alt="" />
          <div className="lm-hero-content">
            <h1 className="lm-hero-title">
              UNINTERRUPTED <em>POWER</em>,<br />
              UNMATCHED <em>VISION</em>
            </h1>
          </div>
        </section>
      </div>

      <nav className="lm-subnav" aria-label="Product categories">
        <div className="lm-subnav-inner">
          {SUBNAV.map((item, i) => (
            <SubnavItem key={i} item={item} />
          ))}
        </div>
      </nav>

      <div className="lm-mobile-bar">
        <span className="lm-mobile-bar-title">Liferaft Modular</span>
        <button className="lm-hamburger" onClick={() => setSidebarOpen(true)} aria-label="Open menu">
          <span /><span /><span />
        </button>
      </div>

      <div
        className={`lm-sidebar-overlay${sidebarOpen ? " open" : ""}`}
        onClick={() => setSidebarOpen(false)}
      />
      <div className={`lm-sidebar${sidebarOpen ? " open" : ""}`}>
        <div className="lm-sidebar-header">
          <span className="lm-sidebar-header-title">Liferaft Modular</span>
          <button className="lm-sidebar-close" onClick={() => setSidebarOpen(false)}>✕</button>
        </div>
        <nav className="lm-sidebar-nav">
          {SUBNAV.map((item, i) => (
            <SidebarRow key={i} item={item} onClose={() => setSidebarOpen(false)} />
          ))}
        </nav>
      </div>

      <div className="lm">
        <nav className="lm-breadcrumb" aria-label="Breadcrumb">
          <div className="lm-breadcrumb-inner">
            <a href="/" className="lm-bc-item">Home</a>
            <span className="lm-bc-sep"><img src={BcSepIcon} alt="" /></span>
            <a href="#" className="lm-bc-item">Business</a>
            <span className="lm-bc-sep"><img src={BcSepIcon} alt="" /></span>
            <span className="lm-bc-item active">Power &amp; Surveillance</span>
          </div>
        </nav>

        <div className="lm-divider-slim"><hr /></div>

        {PRODUCTS.map((product) => (
          <React.Fragment key={product.id}>
            <div id={product.anchor} className="lm-anchor" />
            <section className="lm-section-content">
              <div className="lm-inner">
                <div
                  className="lm-content-grid"
                  style={!product.imgRight ? { flexDirection: "row-reverse" } : {}}
                >
                  <div className="lm-content-left">
                    <h2 className="lm-red-title">{product.title}</h2>
                    <h3 className="lm-subtitle">
                      {product.subtitle.split("\n").map((line, i) => (
                        <React.Fragment key={i}>{line}{i < product.subtitle.split("\n").length - 1 && <br />}</React.Fragment>
                      ))}
                    </h3>
                    {product.paras.map((p, i) => (
                      <p key={i} className="lm-para">{p}</p>
                    ))}
                    <div className="lm-features-tag">
                      <div className="lm-features-tag-bar" />
                      <span className="lm-features-tag-text">Features</span>
                    </div>
                    <ul className="lm-features-list">
                      {product.features.map((f, i) => <li key={i}>{f}</li>)}
                    </ul>
                  </div>

                  <div className="lm-img-col">
                    <div className="lm-img-wrap">
                      {product.imgSrc &&
                        <img className="lm-product-img" src={product.imgSrc} alt={product.title} />
                      }
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div className="lm-divider"><hr /></div>
          </React.Fragment>
        ))}
      </div>
    </>
  );
}